import React from 'react';
import ProtectedRoute from '../../components/ProtectedRoute/ProtectedRoute';
import MagicLinkCallback from '../../features/auth/components/MagicLinkCallback';

const MagicLinkCallbackRoute = () => {
  return (
    <ProtectedRoute requiresAuth={false}>
      <MagicLinkCallback />
    </ProtectedRoute>
  );
};

export default MagicLinkCallbackRoute;
